<template>
  <scroll-view>
    <template slot-scope="visibility">
      <div class="foundation fixed-nav">
        <MainHeader :tiles="false" :fixedMenu="true">
          <svg>
            <use v-if="selectedTranslation === 'en'" xlink:href="#logoFmkSvgEng"></use>
            <use v-else xlink:href="#logoFmkSvg"></use>
          </svg>
        </MainHeader>
        <div class="sections">
          <section class="section-main">
            <HeroSliderAndAnimation
              :header="foundationData.hero.header"
              :description="foundationData.hero.description"
              key="hero"
              :visible="visibility.hero"/>
          </section>
          <DefaultSection
            class="section-main"
            :right="true"
            :shorter="true"
            :mobileRevers="true"
            :headers="foundationData.section2.headers"
            :image="'http://localhost:8000' + foundationData.section2.image"
            imageAnimation="phone"
            :items="foundationData.section2.items"
            key="section2"
            :visible="visibility.section2"
            :mobile="isMobile" />
          <SliderSection
            class="section-main"
            :headers="foundationData.section3.headers"
            :items="foundationData.section3.items"
            key="section3"
            :visible="visibility.section3"
            :mobile="isMobile"/>
          <EventsSection
            id="wydarzenia"
            class="section-main"
            :items="museumData.events.items"
            :header="museumData.events.header"
            key="EventsSection"/>
          <AnimatedSection
            class="section-main"
            :headers="foundationData.section4.headers"
            :image="foundationData.section4.image"
            :background="false"
            key="section4" :visible="visibility.section4"
            :mobile="isMobile"/>
          <section
            class="section-main section5 dark"
            :style="{'background-image': 'url('+ foundationData.section5.image +')'}">
            <div v-if="foundationData.section5.header || foundationData.section5.description" class="container">
              <p class="text-xl" v-accent="foundationData.section5.header"></p>
              <p class="text-xl" v-accent="foundationData.section5.description"></p>
            </div>
          </section>
          <StagesSection
            class="section-main"
            :header="museumData.stages.header"
            :items="museumData.stages.items"
            key="StagesSection"/>
          <DefaultSection
            class="section-main about-section"
            :right="true"
            :mobileRevers="true"
            :headers="foundationData.section7.headers"
            :image="foundationData.section7.image"
            key="section7"
            :scrollTop="visibility.section7"
            :visible="visibility.section7"
            :mobile="isMobile" />
          <MainFooter
            key="footer"
            :visible="visibility.footer"
            :content="footerData"/>
        </div>
      </div>
    </template>
  </scroll-view>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import HeroSliderAndAnimation from '@/components/HeroSliderAndAnimation.vue'
import DefaultSection from '@/components/DefaultSection.vue'
import SliderSection from '@/components/SliderSection.vue'
import AnimatedSection from '@/components/AnimatedSection.vue'
import EventsSection from '@/components/EventsSection.vue'
import StagesSection from '@/components/StagesSection.vue'

export default {
  name: 'foundation',
  components: {
    MainHeader,
    MainFooter,
    HeroSliderAndAnimation,
    DefaultSection,
    SliderSection,
    AnimatedSection,
    EventsSection,
    StagesSection
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ])
  },
  computed: {
    ...mapGetters([
      'foundationData',
      'museumData',
      'footerData',
      'breakpoint',
      'selectedTranslation'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
  .foundation {
    width: 100%;
    overflow: hidden;
  }
  .page-container {
    z-index: 99;
  }
  .dark {
    background-color: $bg-dark;
  }
  .section3 {
    padding: 20px 0;
  }
  .section5 {
    background: {
      repeat: no-repeat;
      position: center;
      size: cover;
    }
    min-height: 630px;
    .container {
      padding: 34px 0 34px 31vw;
    }
    p {
      font-weight: 600;
      text-shadow: 1px 1px #000;
    }
    @include desktop-small {
      min-height: 215px;
    }
    @include tablet {
      .container {
        padding: 34px 0 34px 0;
      }
    }
    @include mobile {
      // background-size: auto 130%;
      // background-position: 30%;
      p {
        letter-spacing: 0.02em;
      }
      .container {
        padding: 40px 0 40px 0;
        // height: 100vh;
        max-width: 88%;
        // max-height: 820px;
      }
    }
  }
</style>
